import { createAsyncThunk, createSlice, isFulfilled } from "@reduxjs/toolkit";
import { getRewardsClaimHistory } from "services/rewardService";
import { getAllRewardsEarned } from "services/rewardService";
import { getAvailableReward } from "services/rewardService";

export const fetchReward = createAsyncThunk("fetchRewardReducer", async () => {
  try {
    const getAvailableRewardRes = await getAvailableReward(
      localStorage.userNameSingh
    );

    return getAvailableRewardRes.data;
  } catch (error) {
    console.log("fetchRewardRewardReducer error", error);
  }
});

export const fetchAllReward = createAsyncThunk(
  "fetchAllRewardReducer",
  async () => {
    try {
      const getAllRewardRes = await getAllRewardsEarned(
        localStorage.userNameSingh
      );

      return getAllRewardRes.data[0];
    } catch (error) {
      console.log("fetchAllRewardRewardReducer error", error);
    }
  }
);

export const fetchClaimHistory = createAsyncThunk(
  "fetchClaimHistoryReducer",
  async (pageNumber) => {
    try {
      const getClaimHistoryRes = await getRewardsClaimHistory(pageNumber);

      return getClaimHistoryRes.data[0].claimRequest;
    } catch (error) {
      console.log("fetchClaimHistoryReducer error", error);
    }
  }
);

const initialState = {
  totalRewardsEarned: 0,
  balanceReward: 0,
  allRewardsEarned: {},
  claimHistory: [],
  claimHistoryPageNumber: 1,
  // likeRewardDetails: [],
  // likeRewardPageNumber: 1,
  // commentRewardDetails: [],
  // commentRewardPageNumber: 1,
  // nftRewardDetails: [],
  // nftRewardPageNumber: 1,
  // eventRewardDetails: [],
  // eventRewardPageNumber: 1,
  // engagementRewardDetails: [],
  // engagementRewardPageNumber: 1,
  isRewardLoading: false,
  isAllRewardLoading: true,
  isClaimHistoryLoading: true,
};

const rewardSlice = createSlice({
  name: "rewards",
  initialState: initialState,
  reducers: {
    claimHistoryReducerPlus(state, action) {
      state.claimHistory.push(...action.payload);
      state.claimHistoryPageNumber += 1;
    },
    rewardReducerReset() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReward.pending, (state) => {
        state.isRewardLoading = true;
      })
      .addCase(fetchReward.fulfilled, (state, action) => {
        state.totalRewardsEarned = action.payload.rewardInSingh;
        state.balanceReward = action.payload.balance;
        state.isRewardLoading = false;
      })
      .addCase(fetchAllReward.pending, (state) => {
        state.isAllRewardLoading = true;
      })
      .addCase(fetchAllReward.fulfilled, (state, action) => {
        state.allRewardsEarned = action.payload;
        state.isAllRewardLoading = false;
      })
      .addCase(fetchClaimHistory.pending, (state) => {
        state.isClaimHistoryLoading = true;
      })
      .addCase(fetchClaimHistory.fulfilled, (state, action) => {
        state.claimHistory = action.payload;
        state.claimHistoryPageNumber = 1;
        state.isClaimHistoryLoading = false;
      });
  },
});

export const { claimHistoryReducerPlus, rewardReducerReset } =
  rewardSlice.actions;
export default rewardSlice.reducer;
